/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_RenewInputs */

const fr_fancy_vast_otter_renew = /** @type {(inputs: Fancy_Vast_Otter_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se réabonner`)
};

/**

* @param {Fancy_Vast_Otter_RenewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_renew = /** @type {((inputs?: Fancy_Vast_Otter_RenewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_RenewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_renew(inputs)
});